import React, {useContext, useState} from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import { PROFILE_ROUTE, FAVOURITES_ROUTE } from '../../../utils/consts';
import { Context } from "../../../index";
import profilePlaceholder from '../../../Assets/profile.svg';
import Favourites from '../../../Assets/hearts/heart-accent.svg';

import styles from './UserMiniProfile.module.css';
import ym from "react-yandex-metrika";

import RegistrationForm from '../../modals/UserForms/RegistrationForm/RegistrationForm';
import ModalPortal from "../../../utils/ModalPortal";

const UserMiniProfile = observer(() => {
    const history = useHistory();
    const { user } = useContext(Context);

    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const getProfileImageUrl = () => {
        if (!user.UserData || !user.UserData.id || !user.UserData.img) {
            return null;
        }

        const userId = user.UserData.id;
        const userImg = user.UserData.img;

        if (userImg === 'EMPTY') {
            return null;
        } else if (typeof userImg === 'string') {
            const constructedPath = `users/user${userId}/${userImg}`;
            const fullImageUrl = process.env.REACT_APP_API_URL + constructedPath;
            return fullImageUrl;
        }
        return null;
    };

    const profileImageUrl = getProfileImageUrl();

    const handleFavoritesClick = (e) => {
        e.stopPropagation();
        if (user.isAuth && user.UserData?.id) {
            history.push(FAVOURITES_ROUTE);
            ym('reachGoal','history.push(FAVOURITES_ROUTE) NAVIGATION')
        } else {
            setShowRegistrationModal(true);
        }
    };

    if (!user.isAuth || !user.UserData) {
        return (
            <div className={styles.navContainer}>
                <button
                    className={styles.loginButton}
                    onClick={() => setShowRegistrationModal(true)} // <- открываем модалку
                >
                    Войти
                </button>

                <RegistrationForm show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)} />
            </div>
        );
    }

    return (
        <div className={styles.navContainer}>
            <button
                className={styles.favoritesButton}
                onClick={handleFavoritesClick}
            >
                <img
                    src={Favourites}
                    alt="Избранное"
                    className={styles.favoritesIcon}
                />
            </button>

            <button
                className={styles.profileButton}
                onClick={() => {
                    history.push(`${PROFILE_ROUTE}/${user.UserData.id}`)
                    ym('reachGoal','history.push(`${PROFILE_ROUTE} NAVIGATION`)')
                }}
            >
                <div className={styles.profileAvatarContainer}>
                    {profileImageUrl ? (
                        <img
                            src={profileImageUrl}
                            alt="Аватар"
                            className={styles.profileAvatarImg}
                        />
                    ) : (
                        <img
                            src={profilePlaceholder}
                            alt="Профиль"
                            className={styles.profileAvatarImg}
                        />
                    )}
                </div>
                <span className={styles.profileNickname}>
                    {user.UserData?.nickname || 'Пользователь'}
                </span>
            </button>
            <ModalPortal>
                <RegistrationForm show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)} />
            </ModalPortal>
        </div>
    );
});

export default UserMiniProfile;